"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "menu", {
    enumerable: true,
    get: ()=>menu
});
const _graphqlRequest = require("graphql-request");
const _productFragment = require("../fragments/product-fragment");
const menu = (0, _graphqlRequest.gql)`
    query menuByType(
        $retailerId: ID!,
        $menuType: MenuType!,
        $filter: MenuFilter!,
        $pagination: Pagination,
        $sort: MenuSort
    ){
        menu(
            retailerId: $retailerId
            menuType: $menuType
            filter: $filter
            pagination: $pagination
            sort: $sort
        ) {
            products {
                ...productFragment
            }
        }
    }
    ${_productFragment.PRODUCT_FRAGMENT}
`;
